//import UserProfile from "views/Pages/UserProfile.js";
import SelectedPlanActions from "components/RTPlanActions/SelectedPlanActions";
import SelectedActions from "components/RTPlanActions/Actions/SelectedActions";
import SelectedMarket from "components/RTMarkets/SelectedMarket";
import SelectedCEECampaign from "components/RTCEE/SelectedCEECampaign";
import SelectedCpe from "components/RTCPE/SelectedCPE";
import SelectedBudget from "components/RTBills/Budget/SelectedBudget";
import Bills from "views/Bills/Bills";

const nomenuRoutes = [
  {
    path: "/user",
    //component: UserProfile,
    layout: "/admin",
  },
  {
    path: "/actionplans/selectedplanaction/selectedaction",
    component: SelectedActions,
    layout: "/admin",
    memv2version: 2,
  },
  {
    path: "/actionplans/selectedplanaction",
    component: SelectedPlanActions,
    layout: "/admin",
    memv2version: 2,
  },
  {
    path: "/markets/selectedmarket",
    component: SelectedMarket,
    layout: "/admin",
    memv2version: 0,
  },
  {
    path: "/cee/selectedcee",
    component: SelectedCEECampaign,
    layout: "/admin",
    memv2version: 0,
  },
  {
    path: "/budget/selectedbudget",
    component: SelectedBudget,
    layout: "/admin",
    memv2version: 0,
  },
  // {
  //   path: "/cpe/selectedcpe",
  //   component: SelectedCpe,
  //   layout: "/admin",
  //   memv2version: 0,
  // },
];
export default nomenuRoutes;
